import { Suspense } from 'react'
import { rootRoutes } from './routes/routes'
import { Route, Switch } from 'react-router-dom'
import Loader from './components/Loader'

export const App = () => {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <Switch>
          {rootRoutes.map((item: any, i: number) => {
            return (
              <Route
                exact
                key={i}
                path={item.pathname}
                component={item.component}
              />
            )
          })}
        </Switch>
      </Suspense>
    </>
  )
}
